module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/066-chad-114b276ecfdc8ea4660bf2a957bd0af8.svg";